<div class="container">
  <div class="close-button d-flex justify-content-end mb-3">
    <button (click)="close()"
      type="button"
      class="btn">
      <span class="material-symbols-outlined">
        close
      </span>
    </button>
  </div>
  <p class="title">
    Input the below details to continue booking
  </p>

  @if (errorMessage) {
    <div
      class="error-div mb-3">
      <span>
        {{errorMessage}}
      </span>
    </div>
  }

  <form [formGroup]="signUpForm"
    autocomplete="false"
    novalidate
    role="form">
    <div class="mb-3 row g-3">
      <div class="col-md-2">
        <select autocomplete="off"
          placeholder="Title"
          formControlName="titleType"
          class="form-control">
          @for (item of titleArray; track item) {
            <option
              [value]="item?.value">
              {{item?.name}}
            </option>
          }
        </select>
        @if ((title?.dirty || title?.touched) && title?.invalid) {
          <div
            class="invalid-feedback">
            Please provide a valid title.
          </div>
        }
      </div>

      <div class="col-md-5">
        <input formControlName="name"
          autocomplete="off"
          placeholder="First name"
          class="form-control"
          type="text">
        @if ((name?.dirty || name?.touched) && name?.invalid) {
          <div
            class="invalid-feedback">
            Please provide a valid name.
          </div>
        }
      </div>

      <div class="col-md-5">
        <input formControlName="family"
          autocomplete="off"
          placeholder="Last name"
          class="form-control"
          type="text">
        @if ((family?.dirty || family?.touched) && family?.invalid) {
          <div
            class="invalid-feedback">
            Please provide a valid name.
          </div>
        }
      </div>

      <div class="col-md-12">
        <input formControlName="email"
          autocomplete="off"
          placeholder="Email Address"
          class="form-control"
          type="email">
        @if ((email?.dirty || email?.touched) && email?.invalid) {
          <div
            class="invalid-feedback">
            @if (email?.hasError('required')) {
              <p class="mb-0"
                >
                email is a required field
              </p>
            }
            @if (email?.hasError('pattern')) {
              <p class="mb-0"
                >
                Please provide a valid email.
              </p>
            }
          </div>
        }
      </div>

      <div class="col-md-6">
        <input formControlName="phoneNumber"
          autocomplete="off"
          placeholder="Phone number"
          class="form-control"
          type="text">
        @if ((phoneNumber?.dirty || phoneNumber?.touched) && phoneNumber?.invalid) {
          <div
            class="invalid-feedback">
            @if (phoneNumber?.hasError('required')) {
              <p class="mb-0"
                >
                phone number is a required field
              </p>
            }
            @if (phoneNumber?.hasError('pattern')) {
              <p class="mb-0"
                >
                Please provide a valid phone number.
              </p>
            }
            @if (phoneNumber?.hasError('minLength') || phoneNumber?.hasError('maxLength')) {
              <p class="mb-0"
                >
                Phone number can only be 11 digits.
              </p>
            }
          </div>
        }
      </div>

      <div class="col-md-6">
        <!-- git push --set-upstream origin development -->
        <input readonly
          ngbDatepicker
          #d="ngbDatepicker"
          (click)="d.toggle()"
          (dateSelect)="onDateSelected($event);"
          name="datepicker"
          [minDate]="minDate"
          [maxDate]="maxDate"
          autocomplete="off"
          placeholder="Date of birth"
          class="form-control"
          type="text"
          [outsideDays]="'hidden'"
          [navigation]="'select'"
          [hidden]=""
          tabindex="-1"
          [autoClose]="true">
        @if ((name?.dirty || name?.touched) && name?.invalid) {
          <div
            class="invalid-feedback">
            Please provide a valid name.
          </div>
        }
      </div>

      <!-- <div class="col-md-6">
      <input formControlName="family" autocomplete="off" placeholder="Gender" class="form-control" type="text">
      <div *ngIf="(family?.dirty || family?.touched) && family?.invalid" class="invalid-feedback">
        Please provide a valid name.
      </div>
    </div> -->

    <div class="col-md-12">
      <input formControlName="password"
        autocomplete="new-password"
        placeholder="Enter Password"
        class="form-control"
        type="password">
      @if ((password?.dirty || password?.touched) && password?.invalid) {
        <div
          class="invalid-feedback">
          @if (password?.hasError('required')) {
            <p class="mb-0"
              >
              password is a required field
            </p>
          }
          @if (password?.hasError('pattern')) {
            <p class="mb-0"
              >
              password must follow the pattern.
            </p>
          }
          @if (password?.hasError('minLength') ) {
            <p class="mb-0"
              >
              password must be at least 8 digits.
            </p>
          }
        </div>
      }
      <div class="form-check">
        <input [checked]="password?.value?.length >= 8"
        autocomplete="off"
        disabled
        class="form-check-input"
        type="checkbox">
        <label class="password-instructions">
          Password must be at least 8 characters long
        </label>
      </div>
      <!-- <div class="form-check">
      <input [checked]="(password?.dirty || password?.touched) && password?.hasError('pattern')"
        autocomplete="off"
        class="form-check-input"
        type="checkbox">
      <label class="password-instructions">
        Password must contain numeric characters
      </label>
    </div> -->
    <div class="form-check">
      <input [checked]="containAlphaNumeric()" disabled autocomplete="off" class="form-check-input" type="checkbox">
      <label class="password-instructions">
        Password must contain alpha-numeric characters
      </label>
    </div>

  </div>

  <div class="col-md-12">
    <input formControlName="confirmPassword"
      autocomplete="off"
      placeholder="Confirm Password"
      class="form-control"
      type="password">
    @if (signUpForm.hasError('passwordMatch') && password?.touched && confirmPassword?.touched) {
      <div
        class="invalid-feedback">
        Passwords Don't Match.
      </div>
    }
  </div>
</div>

<button [disabled]="isLoading"
  (click)="onRegister()"
  type="button"
  class="mx-auto prjct-btn mt-5">
  Enter
</button>
<p class="form-text text-center">
  Already have an account?
  <a (click)="onLogin()"
    class="forgot_password">
    Click to Login
  </a>
</p>
</form>

</div>
